export default {"src":"/_next/static/media/calendar.44d23a28.svg","height":18,"width":18};